import DeleteConfirmation from './delete-modal'
import InputTypeBasic  from './tm-oc-basic'
import InputTypeDetailed from './tm-oc-detailed'
import InputTypeWithinLease from './tm-oc-within-lease'

export default {
  DeleteConfirmation,
  InputTypeBasic,
  InputTypeDetailed,
  InputTypeWithinLease
}